/*export const environment = {
  base_rest_url: 'http://localhost:8080/SIRAnetAng/rest/',
  services_rest_url: 'https://www.sardegnasira.it/mgu/rest/metodi/',
//  login_url: '/SIRAnetAng/auth/checkuser',
  login_url: 'https://www.sardegnasira.it/ras-sp/services/redirect-tomcat.jsp?returnUrl=https%3A%2F%2Fwww.sardegnasira.it%2Fsiranet%2Fflow%2FhomePrivata&originUrl=https://www.sardegnasira.it/cas',
//  logout_url: '/SIRAnetAng/auth/logout',
  logout_url: 'https://www.sardegnasira.it/cas/logout',
  notifyListUrl: 'https://www.sardegnasira.it/GPAtools/flow/notifiche',
  notifyPollerUrl:  'https://www.sardegnasira.it/GPAtools/flow/notifyPoller',
  geoportalUrl:  'https://www.sardegnasira.it/geoportal',
  debug: false,
  production: true
};*/

export const environment = {
  base_rest_url: 'http://localhost:8080/SIRAnetAng/rest/',
  services_rest_url: 'https://test.sardegnasira.it/mgu/rest/metodi/',
  login_url: 'https://test.sardegnasira.it/cas/login?service=https%3A%2F%2Ftest.sardegnasira.it%2Fsiranet%2Fflow%2FhomePrivata', 
  logout_url: 'https://test.sardegnasira.it/cas/logout',
  notifyListUrl: 'https://test.sardegnasira.it/GPAtools/flow/notifiche',
  notifyPollerUrl:  'https://test.sardegnasira.it/GPAtools/flow/notifyPoller',
  geoportalUrl:  'https://test.sardegnasira.it/geoportal',
  debug: false,
  production: true
};